import React, { Component } from 'react'
import Header from '../Components/header/index.jsx'
import Footer from '../Components/Footer/index'
import './index.scss'
import { ArrowRightOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import We from '../home/component/We/index'

class index extends Component {
  componentWillMount() {
    document.title = '高温温湿度_温湿度_智慧物联网_大数据平台_数字孪生_北京锐控自动化科技有限公司|公司简介'
  }
  render() {
    return (
      <div>
        <Header></Header>
        <div className="WeContent">
          <div className="WeContent-title">
            <div className="WeContent-title-h1">关于我们</div>
            <div className="WeContent-title-text">ABOUT　US</div>
          </div>
        </div>
        <div style={{ height: '4.314286rem' }}></div>
        <We titleIshow={false}></We>
        <Footer titleIshow={false}></Footer>
      </div>
    )
  }
}

export default index
